var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { SiteHeaderProvider } from "./site-header-context";
import { SiteFooterProvider } from "./site-footer-context";
import { SiteMenuBarProvider } from "./site-menu-bar-context";
import { ComponentPropsProvider } from "./component-props-context";
import React, { useEffect } from "react";
import { LinearNavigationProvider } from "./linear-navigation-context";
import { createInheritedProvider } from "../utils/create-inherited-provider";
import { useSite } from "../hooks/use-site";
import { usePageEntity } from "../hooks/use-page-entity";
import { ActiveEntityProvider } from "./active-entity-context";
import { useAuth } from "../hooks/use-auth";
import { useActivePerson } from "../hooks/use-active-person";
import { includes } from "lodash";
import { entityTypeNameFor } from "@shapeable/utils";
import { Dialogs } from "../elements/dialogs";
import { useSilentAuthRefreshEffect } from "../hooks/use-silent-auth-refresh-effect";
import { useFullscreen } from "../hooks/use-fullscreen";
import { useLink } from "../hooks/use-link";
import { SiteLoadingLayout } from "../entities/site-loading-layout";
export var defaultExplorerConfig = {
  authenticationRequired: true,
  authenticatedEntities: [],
  defaultView: 'home',
  tabs: {
    // boundary: 'content-bleed',
  },
  siteHeaderProvider: {
    variant: 'default',
    boundary: 'padding'
  },
  siteFooterProvider: {
    boundary: 'padding',
    backgroundColor: 'canvas'
  },
  siteMenuBarProvider: {
    boundary: 'padding',
    delay: 0,
    slideDownDuration: 0
  },
  componentProps: {}
};
export var ExplorerContext = React.createContext(defaultExplorerConfig);
export var ExplorerProvider = createInheritedProvider(ExplorerContext);
// sets up all of the other providers based on the config provided
export var ExplorerProviders = function (props) {
  var context = React.useContext(ExplorerContext);
  var auth = useAuth();
  var navigate = useLink().navigate;
  var pageEntity = usePageEntity();
  var entityTypeName = entityTypeNameFor(pageEntity);
  var activeAccount = useActivePerson();
  var person = activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.person;
  var fullscreen = useFullscreen();
  var path;
  if (typeof window !== 'undefined') {
    path = window.location.pathname + window.location.hash;
  }
  var site = useSite();
  var explorerPage = site.explorerPage,
    setupUrl = site.setupUrl;
  var authenticationRequired = context.authenticationRequired || includes(context.authenticatedEntities, entityTypeName);
  useEffect(function () {
    // Define an async function inside the effect
    var checkLogin = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var url, path;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (typeof window !== 'undefined') {
                url = window.location.href + window.location.hash;
                path = window.location.pathname + window.location.hash;
              }
              if (!(authenticationRequired && !auth.isAuthenticated && url)) return [3 /*break*/, 2];
              return [4 /*yield*/, auth.login({
                url: url,
                path: path
              })];
            case 1:
              _a.sent();
              _a.label = 2;
            case 2:
              return [2 /*return*/];
          }
        });
      });
    };
    // Call the async function
    checkLogin();
  }, [person]); // Empty dependency array runs this effect only once on mount
  useSilentAuthRefreshEffect({
    returnUrl: path
  });
  var LinearNavigationProviderComponent = context.linearNavigationItems ? function () {
    var linearNavigationItems = context.linearNavigationItems();
    return React.createElement(LinearNavigationProvider, {
      value: linearNavigationItems
    }, props.children);
  } : React.Fragment;
  return React.createElement(ActiveEntityProvider, {
    value: explorerPage || pageEntity
  }, React.createElement(SiteFooterProvider, {
    value: {
      boundary: 'none'
    }
  }, React.createElement(SiteHeaderProvider, {
    value: __assign(__assign({}, context.siteHeaderProvider), {
      boundary: fullscreen.isActive ? 'padding' : 'content'
    })
  }, React.createElement(SiteMenuBarProvider, {
    value: context.siteMenuBarProvider
  }, React.createElement(ComponentPropsProvider, {
    value: context.componentProps
  }, React.createElement(LinearNavigationProviderComponent, null, React.createElement(Dialogs, null), authenticationRequired && !auth.isAuthenticated ? React.createElement(SiteLoadingLayout, null) : props.children))))));
};